import { render, staticRenderFns } from "./NovoLayout.vue?vue&type=template&id=8c4e7f6e&"
import script from "./NovoLayout.vue?vue&type=script&lang=js&"
export * from "./NovoLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports